module.exports = __webpack_public_path__ + "static/media/2.14e4521b.svg";